export class ModelStatusPagamento {
    TESTE = 0;
    PAGO = 1;
    PENDENTE = 2;
    CANCELADO_FALHA = 3;
}